<template>
  <div class="start">
    <AppBar class="start-bar"></AppBar>
    <img
      class="bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-start-bg?t=1"
      alt=""
    />
    <img
      class="btn"
      @click="bindNext"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-start-btn"
      alt=""
    />
  </div>
</template>
<script>
import AppBar from './app-bar.vue'
export default {
  components: {
    AppBar
  },
  data() {
    return {}
  },
  mounted() {
    this.$buryPoint('BG_XRWJ_FM', {})
  },
  methods: {
    bindNext() {
      this.$emit('next')
    }
  }
}
</script>
<style lang="scss" scoped>
.start-bar {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
}
.start {
  position: relative;
  .bg {
    width: 375px;
    height: 812px;
  }
  .btn {
    animation: myscale 2s linear infinite;
    position: absolute;
    width: 311px;
    height: 58px;
    left: 50%;
    bottom: 55px;
    transform: translate(-50%, 0%);
  }
}
@keyframes myscale {
  0% {
    transform: translate(-50%, 0%) scale(0.95);
  }
  50% {
    transform: translate(-50%, 0%) scale(1.05);
  }
  100% {
    transform: translate(-50%, 0%) scale(0.95);
  }
}
</style>
